import { mapGetters } from 'vuex';

export default {
  name: 'Controls',
  computed: {
    ...mapGetters([
      'currentRank',
      'duration',
      'openedFrom'
    ])
  },
  props: {
    inGame: {
      type: Boolean,
      default: false
    },
    back: {
      type: String
    }
  }
};
